// extracted by mini-css-extract-plugin
export default {"content-insight":"task-insight_content-insight__+N03D","tabs":"task-insight_tabs__i1-Yq","buttons":"task-insight_buttons__2bEZF","monitors":"task-insight_monitors__O25C2"};